'use strict';

wbApp.controller('NewsCtrl', ['$scope', '$modal', '$translate', 'newsSvc',
function ($scope, $modal, $translate, newsSvc) {

    $scope.news = newsSvc.getAll(true);

    $scope.gridSettings = {
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            { dataField: 'title', caption: $translate.instant('TXT_LBL_TITLE'), dataType: 'string', width: '200px' },
            { dataField: 'subTitle', caption: $translate.instant('TXT_LBL_SUB_TITLE'), dataType: 'string' },
            { dataField: 'publishedAtUtc', caption: $translate.instant('TXT_LBL_PUBLISHED_AT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px',  sortOrder: 'desc' },
            { dataField: 'isVisibleToClients', caption: $translate.instant('TXT_LBL_VISIBLE_TO_CLIENTS'), dataType: 'boolean', width: '60px' },
        ],
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.news = newsSvc.getAll(true);
    });

    $scope.onRowEdit = function (data) {
        newsSvc.getById(data.id).$promise.then(function(model) {
            detailDialogPromise.$promise.then(function () {
                detailDialogPromise.$scope.model = angular.copy(model);
                detailDialogPromise.$scope.onDetailSave = function() {
                    $scope.news = newsSvc.getAll(true);
                };
                detailDialogPromise.show();
            });
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = newsSvc.createNew();
            detailDialogPromise.$scope.onDetailSave = function() {
                $scope.news = newsSvc.getAll(true);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        newsSvc.remove(data.id).$promise.then(function() {
            $scope.news = newsSvc.getAll(true);
        });
    }

    
    var detailDialogPromise = $modal({
        templateUrl: 'setting/news/news-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
